controllers.controller('ModifyPendingTradeController', [
    '$scope', '$state', '$filter', '$q', '$timeout', '$ionicScrollDelegate',
    'config', 'constants', 'Utils', 'ErrorService', 'AssetService', 'OpenTradeService',
    'API', 'UserService', 'InvestCalcService', 'CurrencyConvertService',
    'LocaleService', 'PnlMarginService', 'Storage',
    function ($scope, $state, $filter, $q, $timeout, $ionicScrollDelegate,
              config, Const, Utils, ErrorService, AssetService, OpenTradeService,
              API, UserService, InvestCalcService, CurrencyConvertService,
              LocaleService, PnlMarginService, Storage) {

        $scope.user = UserService.get();
        if ($scope.user && !$scope.user.activeTradingAccount) {
            $state.go('signupPersonalProfile', {cache: false});
        }

        $scope.isFooter = true;
        $scope.showFooter = function (obj) {
            $scope.isFooter = true;
            if (obj && obj.hasOwnProperty('keyboard')) {
                obj.keyboard = 'text';
            }
        };

        $scope.translate = LocaleService.translation;
        $scope.constants = Const;
        $scope.sltpAutoSet = Const.sltpAutoSet || false;
        var orderId = $state.params.orderId;

        $scope.trade = null;
        var initialTrade = {
            openPrice: 0,
            lots: 0,
            action: ''
        };

        $scope.investAmount = {
            value: '',
            keyboard: "text"
        };

        $scope.rate = {
            checked: false,
            value: 0
        };

        $scope.trade = OpenTradeService.collection.get({orderId: parseInt(orderId, 10)});
        $scope.investAmount.value = $scope.trade.lots;
        $scope.user = UserService.get();

        var stopLimit = parseInt($scope.trade.asset.stopLevels / 10, 10);

        var defaultPl = {
            checked: false,
            pips: {
                value: stopLimit || 0,
                lock: true,
                keyboard: "text"
            },
            rate: {
                value: 0,
                lock: false,
                keyboard: "text"
            }
        };

        var disabledPl = {
            checked: false,
            pips: {
                value: 0,
                lock: false,
                keyboard: "text"
            },
            rate: {
                value: 0,
                lock: false,
                keyboard: "text"
            }
        };

        var defaultReach = {
            value: '0.0000',
            keyboard: "text"
        };

        $scope.loss = angular.copy(disabledPl);
        $scope.profit = angular.copy(disabledPl);

        $scope.lossOrigin = angular.copy(defaultPl);
        $scope.profitOrigin = angular.copy(defaultPl);

        $scope.reach = angular.copy(defaultReach);

        $scope.reach.value = $scope.trade.openPrice.toFixed($scope.trade.asset.digits);

        $scope.keyboardModelName = null;
        $scope.isKeyboardShow = false;

        $scope.inputFocus = function (model, name, minval, maxval, digits, viewName) {
            if((model.hasOwnProperty('lock') && !model.lock)|| (model.hasOwnProperty('checked')&& !model.checked)){
                $scope.isKeyboardShow = false;
                $scope.keyboardModelName = null;
                return;
            }

            $scope.isKeyboardShow = true;
            $scope.keyboardModelName = {
                model: model,
                name: name,
                minval: minval,
                maxval: maxval,
                digits: digits,
                viewName: viewName,
            };
            $scope.showFooter();
        };

        $scope.myCallback = function(arg){
            if(arg){
                _.set($scope, arg.name, arg.model.value);
                $scope.isKeyboardShow = false;
                $scope.keyboardModelName = null;
            }
            else{
                $scope.isKeyboardShow = false;
                $scope.keyboardModelName = null;
            }
        };



        //pl: profit/loss, type: pips/rate
        $scope.lock = function (pl, type) {
            //hide footer
            $scope.isFooter = false;

            //unlock all fields and make their type=text
            unlockAll($scope[pl]);

            //lock current field
            $scope[pl][type].lock = true;

            if(type === 'pips') {
                // switch from rate value to pips value - if pips value is negative convert to positive
                $scope[pl][type].value = Math.abs($scope[pl][type].value);
                assetWatcher();
            }

            //change field type to number only for android
            if (Storage.get('platform') === 'android') {
                $scope[pl][type].keyboard = 'number';
            }

            //scroll to bottom
            $ionicScrollDelegate.scrollBottom(true);
        };

        $scope.updateReach = function () {
            //hide footer
            $scope.isFooter = false;

            //change field type to number only for android
            if (Storage.get('platform') === 'android') {
                $scope.reach.keyboard = 'number';
            }
        };

        $scope.updateAmount = function () {
            //hide footer
            $scope.isFooter = false;

            //change field type to number only for android
            if (Storage.get('platform') === 'android') {
                $scope.investAmount.keyboard = 'number';
            }
        };

        //turn off all locked properties
        function unlockAll(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop) && obj[prop].hasOwnProperty('lock')) {
                    obj[prop].lock = false;
                }
                if (obj.hasOwnProperty(prop) && obj[prop].hasOwnProperty('keyboard')) {
                    obj[prop].keyboard = "text";
                }
            }
        }

        function resetObj(obj, defObj) {
            var def = angular.copy(defObj);
            delete def.checked;
            angular.merge(obj, def);
        }

        $scope.pnlData = PnlMarginService.data;

        var lossCheckWatch = $scope.$watch('loss.checked', function (newVal, oldVal) {
            //turn on loss - reset to default
            if (newVal !== oldVal && newVal) {
                resetObj($scope.loss, defaultPl);
            }
            //turn off loss - clear all fields
            if (newVal !== oldVal && !newVal) {
                $scope.loss = angular.copy(disabledPl);
            }
        });

        var profitCheckWatch = $scope.$watch('profit.checked', function (newVal, oldVal) {
            //turn on profit - reset to default
            if (newVal !== oldVal && newVal) {
                resetObj($scope.profit, defaultPl)
            }
            //turn off profit - clear all fields
            if (newVal !== oldVal && !newVal) {
                $scope.profit = angular.copy(disabledPl);
            }
        });

        var lossPipsWatch = $scope.$watch('loss.pips.value', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal && !$scope.loss.rate.lock) {
                $scope.loss.rate.value = calcLossRate();
            }
        });

        var lossRateWatch = $scope.$watch('loss.rate.value', function (newVal, oldVal) {
            if (newVal !== oldVal && !$scope.loss.pips.lock) {
                $scope.loss.pips.value = parseInt(calcLossPips(), 10);
            }
        });

        var profitPipsWatch = $scope.$watch('profit.pips.value', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal && !$scope.profit.rate.lock) {
                $scope.profit.rate.value = calcProfitRate();
            }
        });

        var profitRateWatch = $scope.$watch('profit.rate.value', function (newVal, oldVal) {
            if (newVal !== oldVal && !$scope.profit.pips.lock) {
                $scope.profit.pips.value = parseInt(calcProfitPips(), 10);
            }
        });


        function assetWatcher() {
            if ($scope.loss.checked) {
                //if loss field is not locked - calculate if automatically
                if (!$scope.loss.rate.lock) {
                    $scope.loss.rate.value = calcLossRate();
                    $scope.lossOrigin.rate.value = $scope.loss.rate.value;
                }
                //pips field is not locked - calculate if automatically
                if (!$scope.loss.pips.lock) {
                    $scope.loss.pips.value = parseInt(calcLossPips(), 10);
                    $scope.lossOrigin.pips.value = $scope.loss.pips.value;
                }
            }

            if ($scope.profit.checked) {
                //if loss field is not locked - calculate if automatically
                if (!$scope.profit.rate.lock) {
                    $scope.profit.rate.value = calcProfitRate();
                    $scope.profitOrigin.rate.value = $scope.profit.rate.value;
                }
                //pips field is not locked - calculate if automatically
                if (!$scope.profit.pips.lock) {
                    $scope.profit.pips.value = parseInt(calcProfitPips(), 10);
                    $scope.profitOrigin.pips.value = $scope.profit.pips.value;
                }
            }
        }

        var assetWatch = $scope.$watchGroup(['trade.asset.bid', 'trade.asset.ask'], function (newVal, oldVal) {
            if (newVal && oldVal && (newVal[0] !== oldVal[0] ||  newVal[1] !== oldVal[1])) {
                return assetWatcher();
            }
        });


        var reachWatch = $scope.$watch('reach.value', function (newVal, oldVal) {
            //update value in trade
            //$scope.trade.openPrice = parseFloat(newVal);
            assetWatcher();
        });

        var investAmountWatch = $scope.$watch('investAmount.value', function (newVal, oldVal) {
            $scope.trade.lots = parseFloat(newVal);
        });


        if ($scope.trade.takeProfit > 0) {
            $scope.profit.checked = true;
            $scope.profit.rate.value = $scope.trade.takeProfit;
            $scope.profit.rate.lock = true;

            $scope.profitOrigin.rate.value = $scope.profit.rate.value;
        }

        if ($scope.trade.stopLoss > 0) {
            $scope.loss.checked = true;
            $scope.loss.rate.value = $scope.trade.stopLoss;
            $scope.loss.rate.lock = true;

            $scope.lossOrigin.rate.value = $scope.loss.rate.value;
        }

        assetWatcher();

        $scope.requiredMargin = function () {
            var baseVal = 0,
                convertedCurrency,
                requiredMargin,
                user = UserService.get();

            if ($scope.trade && $scope.trade.asset && parseFloat($scope.trade.lots) > 0) {
                requiredMargin = InvestCalcService.getRequiredMargin(parseFloat($scope.trade.lots), $scope.trade.asset, user);
                baseVal = requiredMargin;
                baseVal = CurrencyConvertService.doConvert($scope.trade.asset.convAssetsMargin, baseVal, $scope.trade.action, $scope.trade.asset.profitMode);
            }

            return baseVal;
        };

        $scope.pendingDistance = function () {
            return $scope.trade ? InvestCalcService.fromPoints(Math.abs($scope.trade.pendingCurrentPrice() - parseFloat($scope.reach.value))/10,  $scope.trade.asset.digits) : '0.00';
        };
        //calculate takeProfit or stopLoss from pips/rate
        function calcProfitPrice(action, pointsRateVal, pointsRateStatus, sltp, investAmount) {
            if (!$scope.trade) return;


            var user = UserService.get(),
                openPrice = parseFloat($scope.reach.value),
                closePrice = pointsRateStatus === 1 ?
                    InvestCalcService.getClosePrice(action, $scope.trade.asset, openPrice, parseFloat(pointsRateVal), sltp) :
                    pointsRateVal,
                lots = investAmount,
                assetCurrency = $scope.trade.asset.currency,
                userCurrency = user.currency,
                pairVal = InvestCalcService.getPairVal(action, openPrice, closePrice, $scope.trade.asset.digits),
                baseVal;

            if ($scope.trade.asset.profitMode === 0) {
                assetCurrency = $scope.trade.asset.outputName.slice(-3);
            }

            if ($scope.trade.asset.profitMode < 2) {
                baseVal = pairVal * $scope.trade.asset.contractSize * lots;
            } else {
                baseVal = pairVal * ($scope.trade.asset.tickPrice / $scope.trade.asset.tickSize) * lots;
            }

            baseVal = CurrencyConvertService.doConvert($scope.trade.asset.convAssets, baseVal, action, $scope.trade.asset.profitMode);

            return parseFloat(baseVal);
        }

        //loss calculations
        function calcLossRate() {
            var digits = $scope.trade.asset.digits,
                points = InvestCalcService.getPoints(parseFloat($scope.loss.pips.value) * 10, digits),
                price = parseFloat($scope.reach.value);

            return $scope.loss.checked ? calcLoss($scope.trade.action, price, points, digits) : 0;
        }

        function calcLossPips() {
            var rateRaw = 0,
                pips = 0;

            if ($scope.trade.action.match(/^sell/)) {
                rateRaw = $scope.loss.rate.value - parseFloat($scope.reach.value);
            }
            if ($scope.trade.action.match(/^buy/)) {
                rateRaw = parseFloat($scope.reach.value) - $scope.loss.rate.value;
            }
            pips = InvestCalcService.fromPoints(rateRaw / 10, $scope.trade.asset.digits);

            return pips.toFixed(0)
        }

        $scope.calcLossValue = function () {
            if (!$scope.trade) return;

            var pipsRate = $scope.loss.pips.lock ? 1 : 2,
                pipsRateValue = pipsRate === 1 ? $scope.loss.pips.value * 10 : $scope.loss.rate.value,
                lossValue = calcProfitPrice($scope.trade.action, pipsRateValue, pipsRate, 'stopLoss', $scope.trade.lots);
            return $scope.loss.checked ? lossValue : 0;
        };

        //profit calculations
        function calcProfitRate() {
            var digits = $scope.trade.asset.digits,
                points = InvestCalcService.getPoints(parseFloat($scope.profit.pips.value) * 10, digits),
                price = parseFloat($scope.reach.value);

            return $scope.profit.checked ? calcProfit($scope.trade.action, price, points, digits) : 0;
        }

        function calcProfitPips() {
            var rateRaw = 0,
                pips = 0;

            if ($scope.trade.action.match(/^sell/)) {
                rateRaw = parseFloat($scope.reach.value) - $scope.profit.rate.value;
            }
            if ($scope.trade.action.match(/^buy/)) {
                rateRaw = $scope.profit.rate.value - parseFloat($scope.reach.value);
            }
            pips = InvestCalcService.fromPoints(rateRaw / 10, $scope.trade.asset.digits);

            return pips.toFixed(0)
        }

        $scope.calcProfitValue = function () {
            if (!$scope.trade) return;

            var pipsRate = $scope.profit.pips.lock ? 1 : 2,
                pipsRateValue = pipsRate === 1 ? $scope.profit.pips.value * 10 : $scope.profit.rate.value,
                profitValue = calcProfitPrice($scope.trade.action, pipsRateValue, pipsRate, 'takeProfit', $scope.trade.lots);
            return $scope.profit.checked ? profitValue : 0;
        };


        function calcProfit(action, price, points, digits) {
            if (action.match(/^sell/)) {
                return (price - points);
            }

            if (action.match(/^buy/)) {
                return (price + points);
            }
        }

        function calcLoss(action, price, points, digits) {
            if (action.match(/^sell/)) {
                return (price + points);
            }

            if (action.match(/^buy/)) {
                return (price - points);
            }
        }

        $scope.pipValue = function () {
            if ($scope.trade.asset && parseFloat($scope.trade.lots) > 0) {
                return calcProfitPrice('buy', 10, 1, 'takeProfit', $scope.trade.lots);
            }
            return 0;
        };


        function validateLimitStop() {
            var asset = $scope.trade.asset,
                action = $scope.trade.action,
                reach = parseFloat($scope.reach.value),
                stopLevels = $scope.trade.asset.stopLevels,
                diff;
            switch (action) {
                case 'buy_stop':
                    diff =  Utils.getDiffInPoints(reach, asset.markupAsk(), asset.digits);
                    return reach > asset.markupAsk() && diff >= stopLevels;
                case 'sell_stop':
                    diff =  Utils.getDiffInPoints(reach, asset.markupBid(), asset.digits);
                    return reach < asset.markupBid() && diff >= stopLevels;
                case 'sell_limit':
                    diff =  Utils.getDiffInPoints(reach, asset.markupBid(), asset.digits);
                    return reach > asset.markupBid() && diff >= stopLevels;
                case 'buy_limit':
                    diff =  Utils.getDiffInPoints(reach, asset.markupAsk(), asset.digits);
                    return reach < asset.markupAsk() && diff >= stopLevels;
                default:
                    return false;
            }
        }

        function validateBuySell() {
            if (!$scope.trade) return;

            var action = $scope.trade.action,
                asset = $scope.trade.asset,
                profit = ($scope.profit.pips.lock ? calcProfitRate() : parseFloat($scope.profit.rate.value)) || 0,
                loss = ($scope.loss.pips.lock ? calcLossRate() : parseFloat($scope.loss.rate.value)) || 0,
                reach = parseFloat($scope.reach.value);

            var stopLimitCheck = function() {
                if (profit === 0) {
                    return parseFloat($scope.loss.pips.value) >= stopLimit;
                } else if (loss === 0) {
                    return parseFloat($scope.profit.pips.value) >= stopLimit;
                } else {
                    return parseFloat($scope.loss.pips.value) >= stopLimit
                        && parseFloat($scope.profit.pips.value) >= stopLimit;
                }
            };

            if (action.match(/^buy/)) {
                if (profit === 0 && loss === 0) {
                    return true;
                } else if (profit === 0) {
                    return reach > loss  && stopLimitCheck();
                } else if (loss === 0) {
                    return reach < profit && stopLimitCheck();
                } else {
                    return reach < profit && reach > loss && stopLimitCheck();
                }
            }

            if (action.match(/^sell/)) {
                if (profit === 0 && loss === 0) {
                    return true;
                } else if (profit === 0) {
                    return reach < loss && stopLimitCheck();
                } else if (loss === 0) {
                    return reach > profit && stopLimitCheck();
                } else {
                    return reach > profit && reach < loss && stopLimitCheck();
                }
            }
        }

        $scope.validate = function () {
            if (!$scope.trade) return;
            var isValidated = validateBuySell(),
                isReachValidated = validateLimitStop(),
                amount = parseFloat($scope.investAmount.value);

            return (amount > 0 && isValidated && isReachValidated)
        };

        $scope.isModified = function () {
            if ($scope.loss.checked === !$scope.trade.stopLoss ||
                $scope.profit.checked === !$scope.trade.takeProfit ||
                parseFloat($scope.reach.value) !== parseFloat($scope.trade.openPrice.toFixed($scope.trade.asset.digits))
            ) {
                return true;
            }

            return (
                $scope.loss.checked && (($scope.loss.pips.value !== $scope.lossOrigin.pips.value) || ($scope.loss.rate.value !== $scope.lossOrigin.rate.value)) ||
                $scope.profit.checked && (($scope.profit.pips.value !== $scope.profitOrigin.pips.value) || ($scope.profit.rate.value !== $scope.profitOrigin.rate.value))
            );
        };

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            isProcess: false,
            back: "root.app.pendingTrades"
        };

        $scope.modal = angular.copy(modalDefaults);

        function checkTrade(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'ModifyTradeController',
                    type: Const.error.type.VALIDATION,
                    code: data.Description || 'orderFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.modifyTrade = function () {
            var trade = {
                OrderID: $scope.trade.orderId,
                OpenPrice: parseFloat($scope.reach.value),
                StopLoss: ($scope.loss.pips.lock ? parseFloat(calcLossRate()) : parseFloat($scope.loss.rate.value)) || 0,
                TakeProfit: ($scope.profit.pips.lock ? parseFloat(calcProfitRate()) : parseFloat($scope.profit.rate.value)) || 0,
                Lots: parseFloat($scope.investAmount.value)
            };

            $scope.modal.isProcess = true;
            $scope.modal.textTitle = LocaleService.translation.messages.orderProcessing;
            $scope.modal.state = true;

            //mockTrade(trade)

            return API.mt4UpdatePosition(trade)
                .then(checkTrade)
                .then(function (data) {

                    $scope.modal.textTitle = LocaleService.translation.modifyTrade;
                    $scope.modal.isError = false;
                    $scope.modal.isProcess = false;
                    $scope.modal.textContent = ['#' + data.Trade.OrderID, LocaleService.translation.successupdated].join(' ');
                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                })
                .catch(function (error) {
                    $scope.modal.textTitle = LocaleService.translation.modifyTrade;
                    $scope.modal.isError = true;
                    $scope.modal.isProcess = false;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                })
        };

        $scope.deleteTrade = function () {
            var trade = {
                OrderID: $scope.trade.orderId
            };

            $scope.modal.state = true;
            $scope.modal.isProcess = true;

            return API.mt4DeletePosition(trade)
                .then(checkTrade)
                .then(function () {
                    $scope.modal.textTitle = LocaleService.translation.deleteOrder;
                    $scope.modal.isError = false;
                    $scope.modal.isProcess = false;
                    $scope.modal.textContent = LocaleService.translation.orderDeleted;
                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                })
                .catch(function (error) {
                    $scope.modal.textTitle = LocaleService.translation.deleteOrderFailed;
                    $scope.modal.isError = true;
                    $scope.modal.isProcess = false;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                });
        };

        function clear() {
            log('clear modify trade controller');

            assetWatch();
            lossCheckWatch();
            profitCheckWatch();
            lossPipsWatch();
            lossRateWatch();
            profitPipsWatch();
            profitRateWatch();
            investAmountWatch();
            reachWatch();

            $scope.pnlData = null;
            $scope.trade = null;
            $scope.user = null;
        }

        $scope.$on('$ionicView.beforeLeave', clear);
        $scope.$on('clear', clear);

    }]);
